import React from 'react';
import { ListBase, ListProps } from 'react-admin';
import ServiceItemsListPage from '../ServiceItems/List/ServiceItemsListPage';
import { ServiceItemsListConfig } from '../ServiceItems/List/types';

const config: ServiceItemsListConfig = {
    detailPath: '/owner_service_items',
    changeInstancesPath: '/owner_change_instances',
    applicationsResource: 'owner_applications',
    servicesResource: 'services',
    teamsResource: 'consumer_teams',
    partyField: {
        label: 'Consumer',
        team: (record) => record.consumer_team,
        pov: 'consumer',
    },
    // items owned by other teams that this owner's services depend on
    dependantResource: 'dependant_service_items',
    dependantPartyField: {
        label: 'Service Owner',
        // a dependant item is one this team consumes, so the party is on the
        // other side from the one the owned list shows
        team: (record) => record.service?.owner,
        pov: 'serviceowner',
    },
    defaultView: 'list',
};

const ServiceItemsList = (props: ListProps) => (
    // page size is the batch the infinite scroll fetches
    <ListBase sort={{ field: 'id', order: 'DESC' }} filter={{ light: true }} perPage={25} {...props}>
        <ServiceItemsListPage config={config} />
    </ListBase>
);

export default ServiceItemsList;
